import React from 'react';
import { useRouter } from '@orderx/lab/ui';
import { PaymentReceiptOverlay } from '../../../components/payment/receipt/overlay/PaymentReceiptOverlay';
import { BrowsePage } from '../../browse/BrowsePage';
import { XSSection } from '../../../xs/component/section/XSSection';
import { XSButton } from '../../../xs/component/button/XSButton';
import { BlockLoader } from '../../../module/global/component/BlockLoader';
import { useXV1 } from '../../../useXV1';
import { XV1 } from '../../../XV1';

export function PaymentIdPage() {
    const router = useRouter();

    const claimPayment = useXV1(XV1.API.MeClaimPaymentPost);
    claimPayment.useRunOnInit({ id: router.params.paymentId });

    return (
        <>
            <XSSection title={'Claim payment'} />

            <XSSection>
                {claimPayment.isLoading ? (
                    <BlockLoader />
                ) : (
                    <>
                        {claimPayment.result?.id ? (
                            <PaymentReceiptOverlay
                                paymentId={claimPayment.result.id}
                                onClose={() => router.push(BrowsePage)}
                            />
                        ) : (
                            <XSButton
                                color={'danger'}
                                icon={'error'}
                                style={{
                                    whiteSpace: 'initial',
                                    textAlign: 'left',
                                    borderRadius: 8,
                                    paddingTop: 16,
                                    paddingBottom: 16,
                                }}>
                                Cannot claim payment as it's already claimed by another user
                            </XSButton>
                        )}
                    </>
                )}
            </XSSection>
        </>
    );
}

PaymentIdPage.route = '/payment/:paymentId';
